<template>
  <div class="page">
    <div class="page-title">新增用戶帳號</div>
    <div class="form-box">
      <userFrom :form="form" ref="form"></userFrom>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBackUser">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addUser } from "@/api/users";
import userFrom from "./components/userFrom.vue";
export default {
  components: { userFrom },
  data() {
    return {
      form: {
        userNo: null,
        name: null,
        gender: null,
        email: null,
        password: null,
        confirmPassword: null,
        areaCode: null,
        phone: null,
        roleId: 4,
        avatar: null,
        country: null,
        area: null,
        district: null,
        address: null,
        status: 1,
        students: [
          {
            userNo: null,
            name: null,
            gender: null,
            isVisible:false,
            status: 1,
            branchSchool: {
              name: {
                en: null,
                zhTc: null,
              },
              abbreviation: null,
            },
            password: null,
            confirmPassword: null,
            subscription: [
              {
                id: 1,
                studentId: 0,
                gradeId: 0,
                type: 0,
                startDate: "",
                endDate: "",
                upgradeWill: 0,
                subscribeStatus: 0,
                upgradedAt: "",
                upgradedType: 0,
              },
            ],
            grade: {
              name: null,
              price: 0,
            },
            avatar: null,
            birthday: null,
            studentCode: null,
          },
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          this.addUser();
        }
      });
    },
    addUser() {
      this.form.userNo = this.form.email
      addUser(this.form).then(() => {
        this.$message.success("新增成功");
        this.onBackUser();
      });
    },
    onBackUser() {
      let path = ``
        path = `/user`
        // this.resolveRouter(path)
        this.$router.push({path: path})
    },
  },
};
</script>

<style lang="scss" scoped>
.page-button {
  margin-top: 20px;
}
.form-box {
  margin-top: 20px;
  overflow: hidden;
  background-color: #fff;
  padding: 20px;
}
</style>